const transitionEnd = require('./transition-end').default;

let showData = {};
let what = '[data-interaction="show"]';
const interactionException = '[data-disable-interaction-event="true"]';
const oncls = 'interaction-active';

function init(item) {
  const triggerEvent = 'click';

  if (item) {
    what = item;
  }

  showData = {
    what,
    triggerEvent,
  };

  $(what)
    .not(interactionException)
    .on(`${triggerEvent}`, (e) => {
      e.preventDefault();
      e.stopPropagation();
      toggle(e.target);
    });
}

function toggle(item, cb) {
  // transitionEnd can be called if/when we call toggle with a 3rd argument
  if (cb) {
    transitionEnd.once(item, cb);
  }

  item.classList.toggle(oncls);
}

function show(item, cb) {
  // transitionEnd can be called if/when we call show with a 3rd argument
  if (cb) {
    transitionEnd.once(item, cb);
  }

  item.classList.add(oncls);
}

function hide(item, cb) {
  // transitionEnd can be called if/when we call hide with a 3rd argument
  if (cb) {
    transitionEnd.once(item, cb);
  }

  item.classList.remove(oncls);
}

function destroy() {
  $(showData.what).off(showData.triggerEvent);
}

function isShown(item) {
  return item.classList.contains(oncls);
}

module.exports = {
  init,
  isShown,
  toggle,
  show,
  hide,
  destroy,
};
